import React from 'react';
import Button from '@mui/material/Button';
import { Box, Typography } from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import CloseIcon from '@mui/icons-material/Close';

function BulkSetRecordingUploadedControl({
    userId,
    moduleObjs,
    enqueueSnackbar,
    colors,
    socketConnected,
    socket,
    setBackdropOpen,
    isThisAdminInViewMode,
}) {

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 800,
        maxHeight: '96%',
        overflowY: 'auto',
        bgcolor: colors.primary[600],
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };
    
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => {
        if (!moduleObjs || moduleObjs.length === 0) {
            enqueueSnackbar("Error: No modules selected.", { variant: "error" });
            return;
        }
        setOpen(true)
    };
    const handleClose = () => { setOpen(false); };

    async function handleSave(_is_recorded) {
        try {
            if (!moduleObjs || moduleObjs.length === 0) {
                enqueueSnackbar("Error: No modules selected.", { variant: "error" });
                return;
            }

            if (!socketConnected) {
                enqueueSnackbar("Socket is not connected. Please refresh the page.", { variant: "error" });
                return;
            }

            for (let i = 0; i < moduleObjs.length; i++) {
                const {
                    zoom_id,
                    date,
                    _time,
                    event_idx,
                    event,
                } = moduleObjs[i];

                setTimeout(() => {
                    // emit to server
                    socket.emit("put.EventRecorded", {
                        admin_uuid: userId,
                        zoom_id: zoom_id,
                        date: date,
                        _time: _time,
                        event_idx: event_idx,
                        event: event,
                        is_recorded: _is_recorded,
                    });
                }, 300);
            }
        } catch (error) {
                console.error(error);
                enqueueSnackbar("Error: Cannot save the changes. Please try again.", { variant: "error" });
            return;
        }

        handleClose();
    };

    return (
        <>
            <Button 
                disabled={isThisAdminInViewMode}
                onClick={handleOpen} 
                sx={{ 
                    flex: 2,
                    width: "100%",
                    height: "100%",
                    bgcolor: colors.greenAccent[800],
                    borderRadius: "0px",
                    textTransform: "none",
                    '&:hover': {
                        bgcolor: colors.greenAccent[900],
                    },
                }}
            >
                Toggle {moduleObjs?.length} {moduleObjs?.length > 1 ? "Modules" : "Module"} as Recording Uploaded on Drive
            </Button>
            <Modal
                aria-labelledby="module-modal"
                aria-describedby="module-modal-description"
                open={open}
                onClose={handleClose}
                closeAfterTransition
                slots={{ backdrop: Backdrop }}
                slotProps={{
                    backdrop: {
                        timeout: 500,
                    },
                }}
            >
                <Fade in={open}>
                    <Box sx={style}>
                        <Typography variant="h4" color={colors.primary[450]}>
                            Toggle {moduleObjs?.length} {moduleObjs?.length > 1 ? "Modules" : "Module"} as Recording Uploaded on Drive
                        </Typography>
                        <CloseIcon sx={{ position: "absolute", right: 10, top: 10, cursor: "pointer" }} onClick={handleClose} />
                        <Box
                            sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 2,
                                mt: 2,
                            }}
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                sx={{ width: 200, mt: 2 }}
                                onClick={() => handleSave(true)}
                            >
                                Set as Recording Uploaded
                            </Button>
                            <Button
                                variant="contained"
                                color="warning"
                                sx={{ width: 200, mt: 2 }}
                                onClick={() => handleSave(false)}
                            >
                                Set as No Recording Uploaded
                            </Button>
                        </Box>
                    </Box>
                </Fade>
            </Modal>
        </>
    )
}

export default BulkSetRecordingUploadedControl